exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disitem[data-v-14870421]{opacity:.4!important}", ""]);

// exports
